module.exports = __webpack_public_path__ + "img/Weapon_62.90f2e1f3.png";